import { Home } from "@mui/icons-material";
import { List } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlPermissions } from "~/__generated__";
import useCurrentUser from "~/modules/auth/hooks/useCurrentUser";
import useHasTenantPermission from "~/modules/auth/hooks/useHasPermission";
import ClientMenu from "~/modules/client/components/ClientMenu";
import useCurrentClient from "~/modules/client/hooks/useCurrentClient";
import FieldworkerMenu from "~/modules/fieldworker/components/FieldworkerMenu";
import PlannerMenu from "~/modules/plannerV2/components/PlannerMenu";

import ProjectMenu from "../../project/components/ProjectMenu";
import useCurrentProject from "../../project/hooks/useCurrentProject";
import AdminMenu from "./AdminMenu";
import GaiaMenuItem from "./GaiaMenuItem";

export default function SideNavigation() {
    const user = useCurrentUser();
    if (!user) throw new Error("User not found");

    const { t } = useTranslation("app");
    const client = useCurrentClient();
    const { data: projectData } = useCurrentProject();
    const isAdmin = useHasTenantPermission(GqlPermissions.Administrator);

    return (
        <List
            component="ul"
            disablePadding
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
            }}
        >
            {user?.fieldworker && !client && <FieldworkerMenu />}

            {projectData?.project && client ? (
                <ProjectMenu client={client} project={projectData?.project} />
            ) : client ? (
                <ClientMenu client={client.client} />
            ) : isAdmin ? (
                <>
                    <PlannerMenu />
                    <AdminMenu />
                </>
            ) : (
                <GaiaMenuItem label={t("sideNavigation.home")} to="/" icon={<Home />} matchExact></GaiaMenuItem>
            )}
        </List>
    );
}
